import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgFilter(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 12.25H6.9368C7.47058 13.9872 9.08782 15.25 11 15.25C12.9122 15.25 14.5294 13.9872 15.0632 12.25L29 12.25V9.75L15.0632 9.75C14.5294 8.01283 12.9122 6.75 11 6.75C9.08782 6.75 7.47058 8.01283 6.9368 9.75L3 9.75L3 12.25ZM11 9.25C10.0335 9.25 9.25 10.0335 9.25 11C9.25 11.9665 10.0335 12.75 11 12.75C11.9665 12.75 12.75 11.9665 12.75 11C12.75 10.0335 11.9665 9.25 11 9.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M29 20.75H25.0632C24.5294 19.0128 22.9122 17.75 21 17.75C19.0878 17.75 17.4706 19.0128 16.9368 20.75H3L3 23.25L16.9368 23.25C17.4706 24.9872 19.0878 26.25 21 26.25C22.9122 26.25 24.5294 24.9872 25.0632 23.25H29V20.75ZM21 20.25C21.9665 20.25 22.75 21.0335 22.75 22C22.75 22.9665 21.9665 23.75 21 23.75C20.0335 23.75 19.25 22.9665 19.25 22C19.25 21.0335 20.0335 20.25 21 20.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
